(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.cc-form');
    const sticky = root.querySelector('[data-cc-sticky]');
    const primary = root.querySelector('[data-cc-main-cta]');
    const dialog = root.querySelector('.cc-lightbox');
    const updateBundle = () => {
      const selected = form.querySelector('[name="quantity"]:checked');
      root.querySelectorAll('[data-cc-price]').forEach(el => el.textContent = selected.dataset.price);
      root.querySelector('[data-cc-delivered]').textContent = selected.dataset.delivered;
      root.querySelector('[data-cc-count]').textContent = `${selected.value} ${selected.value === '1' ? 'set' : 'seturi'} · +16 lei livrare`;
    };
    form.addEventListener('change', updateBundle);
    const showSlide = (index) => {
      root.querySelectorAll('[data-cc-panel]').forEach(panel => { panel.hidden = panel.dataset.ccPanel !== index; });
      root.querySelectorAll('[data-cc-slide]').forEach(button => button.setAttribute('aria-current', String(button.dataset.ccSlide === index)));
      if (index !== '5') {
        const iframe = root.querySelector('.cc-video iframe');
        if (iframe) { iframe.remove(); root.querySelector('[data-cc-video]').hidden = false; }
      }
    };
    root.querySelectorAll('[data-cc-slide]').forEach(button => button.addEventListener('click', () => showSlide(button.dataset.ccSlide)));
    root.querySelectorAll('[data-cc-show-video]').forEach(button => button.addEventListener('click', () => {
      showSlide('5');
      root.querySelector('.cc-gallery').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      root.querySelector('[data-cc-video]').focus({ preventScroll: true });
    }));
    root.querySelector('[data-cc-video]').addEventListener('click', (event) => {
      const button = event.currentTarget;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/aXzq5LLy9Xw?autoplay=1&rel=0';
      iframe.title = 'Demonstrație unghieră Purpley';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      button.hidden = true;
      button.parentElement.append(iframe);
    });
    root.querySelectorAll('[data-cc-lightbox]').forEach(link => link.addEventListener('click', event => {
      if (!dialog.showModal) return;
      event.preventDefault();
      const img = dialog.querySelector('img');
      img.src = link.href;
      img.alt = link.querySelector('img').alt;
      dialog.showModal();
    }));
    root.querySelector('[data-cc-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const syncSticky = () => {
      const rect = primary.getBoundingClientRect();
      sticky.hidden = window.scrollY < 180 || (rect.top < innerHeight && rect.bottom > 0);
    };
    new IntersectionObserver(syncSticky, { threshold: [0, 1] }).observe(primary);
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky, { passive: true });
    new MutationObserver(() => {
      const stickyButton = sticky.querySelector('button');
      ['aria-busy', 'aria-disabled'].forEach(attr => {
        if (primary.hasAttribute(attr)) stickyButton.setAttribute(attr, primary.getAttribute(attr));
        else stickyButton.removeAttribute(attr);
      });
    }).observe(primary, { attributes: true, attributeFilter: ['aria-busy', 'aria-disabled'] });
    document.addEventListener('ajaxProduct:error', () => form.querySelector('.cc-error').scrollIntoView({ block: 'center' }));
    document.querySelectorAll('cart-count').forEach(counter => {
      const syncLabel = () => {
        const count = Number(counter.textContent.trim()) || 0;
        counter.setAttribute('aria-label', `${count} ${count === 1 ? 'produs' : 'produse'}`);
      };
      new MutationObserver(syncLabel).observe(counter, { childList: true, characterData: true, subtree: true });
      syncLabel();
    });
    updateBundle(); syncSticky();
  };
  document.querySelectorAll('[data-cc-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-cc-root]')));
})();
